<template>
  <v-chip
    class="qa-priority-chip"
    size="small"
    color="surface-primary"
    data-locator="qa-priority-chip"
  >
    <app-material-icon
      :name="getPriorityMeta.icon"
      :color="getPriorityMeta.iconColor"
      size="xs"
      class="mr-2"
      :data-locator="getPriorityMeta.locatorValue"
      aria-hidden="true"
    />
    <span class="text-text-tertiary detail-md-bold">
      {{ getPriorityMeta.label }}
    </span>
  </v-chip>
</template>

<script>
import { QAPriority, getQAPriorityMeta } from '@/project/question-answer/constants/qaPriority'

export default {
  name: 'QuestionAnswerPriorityChip',
  props: {
    priority: {
      type: String,
      required: true,
      validator: (value) => Object.values(QAPriority).includes(value),
    },
  },
  computed: {
    getPriorityMeta () {
      return getQAPriorityMeta(this.priority || QAPriority.MEDIUM, this.$t)
    },
  },
}
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";

.qa-priority-chip {
  border: get-border();
}
</style>
